import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from "@angular/forms";

@Directive({
  selector: '[only-alphanumeric]'
})
export class AlphanumericDirective {

  constructor(private element:ElementRef,
              private control : NgControl) { }

  @HostListener('input') onInput(event:KeyboardEvent) {
    const text = this.element.nativeElement.value;
    if(text.length >= 1) {
      if (!text[0].replace(/\s/g, '').length) {
        this.control.control.setValue( text.replace(/[^0-9a-zA-ZáéíóúüñÁÉÍÓÚÜÑñ\s]/g, '').trim() );
      } else {
        this.control.control.setValue( text.replace(/[^0-9a-zA-ZáéíóúüñÁÉÍÓÚÜÑñ\s]/g, '') );
      }
    } 
  }

}
